export default __webpack_public_path__ + "media/assets/fonts/081_font_iom-541a4df255fd32a810329d96c2a2a447.eot";